import React from 'react';
import './BankTransferInfoModal.css';

const BankTransferInfoModal = ({ onClose, bookingDetails }) => {
  const bankInfo = {
    bank: 'Bancolombia',
    accountType: 'Ahorros',
    accountNumber: '78900006275',
    accountHolder: 'M&G Centro de Distribuciones SAS',
    nit: '901.824.734-2',
  };

  const handleCopyAccount = () => {
    navigator.clipboard.writeText(bankInfo.accountNumber);
    alert('Número de cuenta copiado al portapapeles!');
  };

  return (
    <div className="bank-transfer-modal-overlay" onClick={onClose}>
      <div className="bank-transfer-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="bank-transfer-modal-close-button" onClick={onClose}>&times;</button>
        <h2>Información para Transferencia Bancaria</h2>

        <div className="bank-info-details">
          <img src="/iconbbia.png" alt="Bancolombia Logo" className="bank-logo" /> {/* Placeholder for logo */}
          <p><strong>Banco:</strong> {bankInfo.bank}</p>
          <p><strong>Tipo de Cuenta:</strong> {bankInfo.accountType}</p>
          <p><strong>Número de Cuenta:</strong> {bankInfo.accountNumber}</p>
          <p><strong>Titular:</strong> {bankInfo.accountHolder}</p>
          <p><strong>NIT:</strong> {bankInfo.nit}</p>
        </div>

        <button onClick={handleCopyAccount} className="copy-account-button">
          Copiar Número de Cuenta
        </button>

        <p className="transfer-instructions">
          Por favor, realiza la transferencia por <strong>${bookingDetails.precioTotal.toLocaleString('es-CO')} COP</strong>.
          Recibirás un email con estos datos y la confirmación de tu reserva pendiente.
          Tu reserva será confirmada una vez verifiquemos la transferencia.
        </p>

        <button onClick={onClose} className="close-modal-button">
          Entendido / Cerrar
        </button>
      </div>
    </div>
  );
};

export default BankTransferInfoModal;
